import * as React from 'react'

import { useReadAloud } from './readAloudContext'
import { ReadAloudSection } from './readAloudSection'

import { safeParseHtml } from '../../libs/safeHtml'
import { ClipSource } from '../../libs/speech/clipSource'

interface ReadAloudHtmlProps {
  className?: string;
  element?: string;
  html: string;
  label: string;
  source?: ClipSource | null;
}

const ReadAloudHtml = ({ className, element = 'div', html, label, source, }: ReadAloudHtmlProps) => {
  const { readAloudEnabled, } = useReadAloud()

  if (!readAloudEnabled) { return React.createElement(element, { className, }, safeParseHtml(html)) }

  return <ReadAloudSection className={className} html={html} label={label} source={source} />
}

export { ReadAloudHtml }
